module.exports = __webpack_public_path__ + "media/img/pages/companies/loterie-romande-horizontal-1fd98b209c98a9a3bf56b70fb453f62e.png";